// カレンダー表示設定
export const CALENDAR_SETTINGS = {
  START_HOUR: 7,
  END_HOUR: 22,
  TIME_SLOT_MINUTES: 15,
  GRID_ROW_HEIGHT: 80, // 1時間あたりのピクセル高さ
};

// 会議室定義
export const ROOMS = {
  G: {
    id: 'G',
    name: '会議室G',
    capacity: 10,
  },
  B: {
    id: 'B',
    name: '会議室B',
    capacity: 12,
  },
  GB: {
    id: 'GB',
    name: '会議室G+B（連結）',
    capacity: 22,
  },
};

export const ROOM_TYPES = ['G', 'B', 'GB'];

// 繰り返し予約パターン
export const RECURRING_PATTERNS = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
};

// APIエンドポイント
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// 予約制限
export const RESERVATION_LIMITS = {
  MIN_DURATION_MINUTES: 15,
  MAX_DURATION_HOURS: 24,
  MAX_ADVANCE_DAYS: 365,
};

// ユーザーロール
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
};

// 時間フォーマット
export const TIME_FORMAT = 'HH:mm';
export const DATE_FORMAT = 'yyyy-MM-dd';
export const DATETIME_FORMAT = 'yyyy-MM-dd HH:mm';
